import { Component, OnInit } from "@angular/core";
import { CatColonias } from "../../entidades/entidades";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Observable } from "rxjs";
import { MenuItem } from "primeng/api";


declare var $: any;

@Component({
  selector: "app-catalogos",
  templateUrl: "./catalogos.component.html",
  styleUrls: ["./catalogos.component.css"],
})
export class CatalogosComponent {
  public id$: Observable<number>;
  message: string;
  errorMessage: any;
  catcolonias: CatColonias[] = [];
  catcolonia: CatColonias = new CatColonias();
  public menu: MenuItem[];
  public menuSelected: MenuItem = { label: "Colonias" };

  constructor(muestraMensaje: MuestraMensaje) {
    this.message = "Catalogo de Colonias";
  }

  muestraMensaje: MuestraMensaje = new MuestraMensaje();

  ngOnInit() {
    this.menu = [
          {
            label: 'Administración', 
            icon: 'pi pi-sitemap',
            items: [
              {
                label: "Atributo Inmuebles",
                icon: "pi pi-tag",
                command: (event) => {
                  this.menuSelected = event.item;
                }
              },
              {
                label: "Calendario",
                icon: "pi pi-calendar",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },  
              // {
              //   label: "Departamentos",
              //   icon: "pi pi-table",
              //   command: (event) => {
              //   this.menuSelected = event.item;
              //   }, 
              // },
              {
                label: "Estatus",
                icon: "pi pi-info-circle",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Grupo Parametros",
                icon: "pi pi-tags",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              }, 
              {
                label: "Motivo Cancelaciones",
                icon: "pi pi-ban",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
             /* {
                label: "Motivo Levantamientos",
                icon: "pi pi-eject",
                command: (event) => {
                 this.menuSelected = event.item;
                },
              }, */      
              // {
              //   label: "Roles",
              //   icon: "pi pi-sliders-h",
              //   command: (event) => {
              //     this.menuSelected = event.item;
              //   },
              // },
              {
                label: "Sucursales",
                icon: "pi pi-shopping-cart",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Comprobantes",
                icon: "pi pi-copy",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Documentos",
                icon: "pi pi-folder",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Unidad Cobros",
                icon: "pi pi-plus-circle",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Unidad Medidas",
                icon: "pi pi-filter",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },

              {
                label: "Parametros",
                icon: "pi pi-chart-line",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },

              {
                label: "Tipo Observaciones",
                icon: "pi pi-thumbtack",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },

              
            ]
          },
          {
            label: "Fiscalización",
            icon: "pi pi-chart-bar",
            items: [
              {
                label: "Tipo Bloqueos",
                icon: "pi pi-unlock",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Contrato Personas",
                icon: "pi pi-user-edit",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              }, {
                label: "Intereses de Convenio",
                icon: "pi pi-ticket",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
            ]  
          },
          {
            label: "Ingresos",
            icon: "pi pi-dollar",
            items:[
              {
                label: "Bancos",
                icon: "pi pi-money-bill",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },  
              // {
              //   label: "Cargos",
              //   icon: "pi pi-plus",
              //   command: (event) => {
              //     this.menuSelected = event.item;
              //   },
              // },  
              {
                label: "Categoria Inmuebles",
                icon: "pi pi-home",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              // {
              //   label: "Descuentos",
              //   icon: "pi pi-sort-amount-down",
              //   command: (event) => {
              //     this.menuSelected = event.item;
              //   },
              // },
              {
                label: "Medio Pagos",
                icon: "pi pi-ticket",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              }, 
              {
                label: "Usos CFDI",
                icon: "pi pi-file-o",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
            ]  
          },
          {
            label: "Padrón y Lecturas",
            icon: "pi pi-search",
            items: [ 
              {
                label: "Agua Zonas",
                icon: "pi pi-cloud",
                command: (event) => {
                this.menuSelected = event.item;
                }, 
              },
              {
                label: "Anomalias",
                icon: "pi pi-exclamation-triangle",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              /*{
                label: "Estado Funcionamientos",
                icon: "pi pi-check-circle",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },*/
              /*{
                label: "Levantamientos",
                icon: "pi pi-sort-up",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },*/
              {
                label: "Marca Medidores",
                icon: "pi pi-bookmark",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Personas",
                icon: "pi pi-users",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tarifas de Consumo",
                icon: "pi pi-sort-numeric-up-alt",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Consumos",
                icon: "pi pi-video",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Giros",
                icon: "pi pi-spinner",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Ingreso",
                icon: "pi pi-sign-in",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Medidores",
                icon: "pi pi-cog",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Periodos",
                icon: "pi pi-clock",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Servicio",
                icon: "pi pi-briefcase",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Tomas",
                icon: "pi pi-camera",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tipo Usos",
                icon: "pi pi-palette",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Tomas de Diametro",
                icon: "pi pi-circle-off",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              }, 
              /*{
                label: "Ubicación Medidores",
                icon: "pi pi-map-marker",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },*/
              {
         
                label: "Vencimientos",
                icon: "pi pi-calendar-times",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
            ]
          },
          {
            label: "Servicios",
            icon: "pi pi-desktop",
            items: [
              {
                label: "Conceptos",
                icon: "pi pi-ellipsis-v",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                 label: "Cuentas Contables",
                 icon: "pi pi-file",
                 command: (event) => {
                    this.menuSelected = event.item;
                 },
              },
              {
                label: "Concepto Costos",
                icon: "pi pi-chart-line",
                command: (event) => {
                this.menuSelected = event.item;
                },
              },
              {
                label: "Etapas de Tramite",
                icon: "pi pi-external-link",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Flujo de Trámites",
                icon: "pi pi-spinner",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Fundamentos Legales",
                icon: "pi pi-folder-open",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Grupo Conceptos",
                icon: "pi pi-list",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Requisitos",
                icon: "pi pi-inbox",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
            ]
          },
          {  
            label: 'Ubicación', 
            icon: 'pi pi-globe',
            items: [
              {
                label: "Calles",
                icon: "pi pi-reply",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              {
                label: "Colonias",
                icon: "pi pi-th-large",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },    
              // {
              //   label: "Departamento Dir.",
              //   icon: "pi pi-compass",
              //   command: (event) => {
              //     this.menuSelected = event.item;
              //   },
              // },
              {
                label: "Población",
                icon: "pi pi-user",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },
              /*{
                label: "Estados",
                icon: "pi pi-tablet",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              },*/
              /*{
                label: "Municipios",
                icon: "pi pi-mobile",
                command: (event) => {
                  this.menuSelected = event.item;
                },
              }*/
            ]
          },          
        ]
      }
}
